<script>
  import Link from '../../utils/link.html';
  import Form from '../../components/inputs/form';
  import InputText from '../../components/inputs/text';
  import InputDate from '../../components/inputs/date';
  import Loader from '../../components/ui/loader.html';
  import Menu from '../../components/navigation/menu';
  import { onMount, afterUpdate, getContext } from 'svelte';
  import { gql } from 'apollo-boost';

  import HouseholdInfo from './components/sections/household.info.html';
  import HouseholdVIP from './components/sections/household.vip.html';
  import HouseholdPeople from './components/sections/household.people.html';
  import HouseholdActivity from './components/sections/household.activity.html';

  const client = getContext('apollo');

  import { HOUSEHOLD } from '../../graphql/households';

  const components = {
    info: HouseholdVIP,
    vip: HouseholdVIP,
    people: HouseholdPeople,
    activity: HouseholdActivity
  };

  export let match = {};
  let loading = true;
  let household;
  let error;
  $: current = components[match.params.section] || components['info'];

  const menu = [
    {
      id: 'info',
      label: 'Household Info',
      link: `/households/view/${match.params.id}`
    },
    /*{
      id: 'vip',
      label: 'VIP Info',
      link: `/households/view/${match.params.id}/vip`
    },*/
    {
      id: 'people',
      label: 'People',
      link: `/households/view/${match.params.id}/people`
    },
    {
      id: 'activity',
      label: 'Activity',
      link: `/households/view/${match.params.id}/activity`
    }
    /*{
      id: 'particpation',
      label: 'Registrations',
      link: `/households/view/${match.params.id}/registrations`
    }*/
  ];

  async function getPerson() {
    try {
      const { data } = await client.query({
        query: HOUSEHOLD,
        variables: { id: match.params.id }
      });

      household = data.household;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  onMount(getPerson);
</script>

{#if loading}
<Loader></Loader>
{/if} {#if !loading}
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{household.primary.person.lastName} Household</h1>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    <Menu active={match.params.section || 'info'} items={menu} />
  </div>
</div>

<svelte:component
  this="{current}"
  bind:value="{household}"
  id="{match.params.id}"
/>
{/if}
